(function f(doc) {
    /**
    * shorthand clean log to console
    * @param {string} strName
    * @param {object variant} objValue
    */
    window.log = (...args) => {
    // eslint-disable-next-line no-console
        console.log(...args);
    };

    const u = {
        // Object of global variables.
        globals: {},

        /**
         * Sets a global variable.
         * @param {String} key Object key
         * @param {Mixed} value value of object, could be anything.
         * @returns global value.
         */
        setGlobal(key, value) {
            u.globals[key] = value;
            return u.globals[key];
        },

        // Utilities for the window
        qsa: (selector, context = doc) => [...context.querySelectorAll(selector)],
        qs:  (selector, context = doc) => context.querySelector(selector),


        pushIfNotExist: (array, el) => array.indexOf(el) === -1 && array.push(el),

        removeFromArr: (arr, value) => {
            let i = 0;
            while (i < arr.length) {
                if (arr[i] === value)
                    arr.splice(i, 1);
                else
                    ++i;
            }
            return arr;
        },

        /**
        * Gets an iterable element for the passed element/s
        */
        getList(selector) {
            const selectorName = Object.prototype.toString.call(selector);
            switch (selectorName) {
            case '[object HTMLCollection]':
            case '[object NodeList]':
                return [...selector];
            case '[object Array]':
                return selector;
            case '[object String]':
                return this.qsa(selector);
            case '[object Null]':
            case '[object Undefined]':
                return [];
            default:
                return [selector];
            }
        },

        has: (object, key) => object != null && hasOwnProperty.call(object, key),

        /**
         * Iterates over an object's own properties, executing the `callback` for each.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} callback The function executed per own property.
         */
        forOwn(object, callback) {
            for (const key in object) {
                if (this.has(object, key))
                    callback(object[key], key, object);
            }
        },

        /**
       * An iteration utility for arrays and objects.
       *
       * @private
       * @param {Array|Object} object The object to iterate over.
       * @param {Function} callback The function called per iteration.
       */
        each(object, callback, end = null, i = 0) {
            if (typeof object === 'string')
                object = u.qsa(object);
            let length = object ? object.length : 0;
            if (typeof length == 'number' && length > -1) {
                length = end || length;
                while (i < length) {
                    callback(object[i], i, object);
                    i += 1;
                }
            } else {
                u.forOwn(object, callback);
            }
        },

        /**
         * @param {FUnction} callback callback function to run on the returned data
         */
        ajaxGet: (url, { data = null, done, fail, type = 'GET' }) => {
            // log('data', data);
            const request = new XMLHttpRequest();
            request.open(type, url, true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            request.onreadystatechange = () => {
                if (request.readyState === 4 && request.status === 200) {
                    try {
                        done(JSON.parse(request.responseText));
                    } catch (err) {
                        fail(err.message, JSON.parse(request.responseText));
                    }
                }
            };
            request.send(data);
            return false;
        },

        /**
         * DOM Ready
         */
        docReady: (callback) => {
            doc.readyState === 'complete' || (doc.readyState !== 'loading' && doc && !doc.documentElement.doScroll)
                ? callback()
                : doc.addEventListener('DOMContentLoaded', callback);
        },

        createElement(name, attrs) {
            const el = document.createElement(name);
            if (!attrs || typeof attrs !== 'object')
                return el;
            u.each(attrs, (attributeValue, attribute) => {
                switch (attribute) {
                case 'class':
                    el.className = attributeValue;
                    break;
                case 'dataset':
                    u.each(attributeValue, (dataVal, dataKey) => { el.dataset[dataKey] = dataVal; });
                    break;
                case 'text':
                    el.textContent = attributeValue;
                    break;
                case 'html':
                    el.innerHTML = attributeValue;
                    break;
                default:
                    el.setAttribute(attribute, attributeValue);
                    break;
                }
            });
            return el;
        },

        addClass:    (nodes, className) => u.each(u.getList(nodes), el => el.classList.add(...className.split(' '))),
        removeClass: (nodes, className) => u.each(u.getList(nodes), el => el.classList.remove(...className.split(' '))),
        toggleClass: (nodes, className, force = undefined) => u.each(u.getList(nodes), el => el.classList.toggle(className, force)),
        hasClass:    (node, className) => node.classList.contains(className),
        css:         (nodes, cssObj) => u.each(u.getList(nodes), node => u.each(cssObj, (val, prop) => { node.style[prop] = val; })),
        text:        (nodes, string) => u.each(u.getList(nodes), (node) => { node.textContent = string; }),
        prop:        (nodes, prop, value) => u.each(u.getList(nodes), (node) => { node[prop] = value; }),
        titleCase:   str => str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase()),
        camelCased:  str => str.replace(/-([a-z])/g, g => g[1].toUpperCase()),

        /**
         * Add event listener to several elements.
         * @param {*} args Arguments { els, event, callback, options }
         * @returns null
         */
        addEvent(...args) {
            const els      = args.shift();
            const events   = args.shift().split(' ');
            const callback = args.shift();
            const options  = args.shift() || false;
            return u.each(u.getList(els), el => u.each(events, event => el.addEventListener(event, callback, options)));
        },

        /**
         * Fires an event on an element.
         * @param {DOM Element} el An HTML element
         * @param {String} name Name of event (click)
         * @param {Boolean} custom Fire a custom event or regular event
         * @param {Array} detail Array of details for custom events
         * @returns Event
         */
        trigger(el, name, custom = false, detail = []) {
            const event = custom ? new CustomEvent(name, { detail }) : new Event(name, detail);
            el.dispatchEvent(event);
            return event;
        },

        getHash: () => window.location.hash.substring(1) || '',

        splitText(text, attr = '') {
            const words = text.split(' ');
            const wordWrap   = '<span style="display:inline-block;position:relative" class="split-word">';
            const letterWrap = '<span style="display:inline-block;position:relative" class="split-letter" data-animate="splitLetter">';
            let final = '';
            words.forEach((letter) => {
                final += wordWrap + letterWrap;
                final += letter.split('').join(`</span>${letterWrap}`);
                final += '</span></span> ';
            });
            return final;
        },

        // Object.fromEntries(new FormData().entries())
        newFormData(values, form = null) {
            const formData = form ? new FormData(form) : new FormData();
            u.each(values, (val, key) => {
                if (typeof val === 'object')
                    val = JSON.stringify(val);
                formData.append(key, val);
            });
            return formData;
        },

        getFormData(form, stringify = false) {
            const obj = Object.fromEntries(new FormData(form).entries());
            return !stringify ? obj : JSON.stringify(obj);
        },
    };

    class NewFetch {
        constructor(body) {
            if (body instanceof HTMLFormElement)
                this.body = u.newFormData({}, body);
            else if (body instanceof FormData)
                this.body = body;
            else
                this.body = u.newFormData(body);

            this.url  = this.body.get('url') || u.globals.fetchUrl || '';
            this.body.delete('url');

            // Append global params if they do not exits.
            u.each(u.globals.fetchParams || {}, (val, key) => !this.body.get(key) && this.body.append(key, val));
        }

        get() {
            return fetch(this.url, { method: 'GET' }).then(this.handleResponse.bind(this));
        }

        post() {
            return fetch(this.url, {
                method: 'POST',
                body:   this.body,
            }).then(this.handleResponse.bind(this));
        }

        handleResponse(res) {
            return res.text().then((text) => {
                const data = text && JSON.parse(text);
                console.log('handleResponse', data);
                const { success } = data;
                this.message = success ? data.data.message : data.data;
                this.message = this.message || res.statusText || 'An error occurred.';
                return !res.ok || success === false ? Promise.reject(this.message) : data;
            });
        }
    }

    u.newFetch = body => new NewFetch(body);

    window.utilities = u;
}(typeof document === 'object' && document));
